import React from 'react';
import css from './index.less';
import { Space, Button } from 'antd';
import { KimUser } from '../components/KimUser';

interface IProps {
    onSearchOnCallUser?: THandleSearch;
    chunkLoadErrorVisible: boolean;
    oncallList?:Array<ICallUser>;
}
interface ICallUser {
    name: string;
    username: string;
}
interface IState {
    oncallList: Array<ICallUser>;
}
type THandleSearch = () => Promise<Array<ICallUser>>;
export class ErrorComp extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            oncallList: [],
        };
    }
    public componentDidMount(): void {
        this.searchUser();
    }

    public async searchUser() {
        if (!!this.props.oncallList?.length) {
            this.setState({
                oncallList: this.props.oncallList?.filter(it => it.username) || [],
            });
            return;
        }
        if (!this.props.onSearchOnCallUser) {
            return;
        }
        try {
            const dataList = await this.props.onSearchOnCallUser();
            this.setState({
                oncallList: dataList.filter(it => it.username) || [],
            });
        } catch (e) { }
    }

    public render() {
        return (
            <div className={css.pageErrorHandle}>
                <div className={css.pageErrorComp}>
                    <div>
                        出现了严重错误，请联系平台负责人：
                    </div>
                    <Space size={10} className={css.oncallList}>
                        {
                            this.state.oncallList.map(user => {
                                return <div key={user.username} className={css.oncallUser}>
                                    <KimUser name={user.name} username={user.username}/>
                                </div>;
                            })
                        }
                    </Space>
                </div>
            </div>
        );
    }
}
